import React from 'react';
import { Box, BottomNavigation as MuiBottomNavigation, BottomNavigationAction } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

export const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        width: '359px',
      }}
    >
      <MuiBottomNavigation
        value={location.pathname}
        onChange={(event, newValue) => {
          navigate(newValue);
        }}
        showLabels
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: '26px',
          width: '359px',
          height: '65px',
          minHeight: '65px',
          boxShadow: '0 8px 25px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.05)',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            width: '48px',
            maxWidth: 'none',
            height: '48px',
            py: 0,
            px: 0,
            color: '#999999',
            transition: 'none',
          },
          '& .MuiBottomNavigationAction-root:not(:last-of-type)': {
            mr: '38px',
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '11px',
            marginTop: '4px',
            fontWeight: 500,
            transition: 'none',
          },
          '& .Mui-selected': {
            color: '#007AFF',
          },
          '& .Mui-selected .MuiBottomNavigationAction-label': {
            fontSize: '11px',
            fontWeight: 600,
          },
        }}
      >
        <BottomNavigationAction
          label="Главная"
          icon={
            <img 
              src="/icons/home.svg" 
              alt="Главная" 
              style={{ 
                width: 33, 
                height: 33,
                filter: isActive('/') 
                  ? 'invert(34%) sepia(98%) saturate(1892%) hue-rotate(204deg) brightness(100%) contrast(101%)'
                  : 'invert(60%) sepia(0%) saturate(0%) brightness(100%) contrast(80%)'
              }} 
            />
          }
          value="/"
        />
        <BottomNavigationAction
          label="Записи"
          icon={
            <img 
              src="/icons/calendar_month.svg" 
              alt="Записи" 
              style={{ 
                width: 33, 
                height: 33,
                filter: isActive('/appointments')
                  ? 'invert(34%) sepia(98%) saturate(1892%) hue-rotate(204deg) brightness(100%) contrast(101%)'
                  : 'invert(60%) sepia(0%) saturate(0%) brightness(100%) contrast(80%)'
              }} 
            />
          }
          value="/appointments"
        />
        <BottomNavigationAction
          label="Кабинет"
          icon={
            <img 
              src="/icons/account_circle.svg" 
              alt="Кабинет" 
              style={{ 
                width: 33, 
                height: 33,
                filter: isActive('/cabinet')
                  ? 'invert(34%) sepia(98%) saturate(1892%) hue-rotate(204deg) brightness(100%) contrast(101%)'
                  : 'invert(60%) sepia(0%) saturate(0%) brightness(100%) contrast(80%)'
              }} 
            />
          }
          value="/cabinet"
        />
      </MuiBottomNavigation>
    </Box>
  );
};